import md5 from "js-md5";
class utilMethod {
  edit(res, data) {
    for (let item in res) {
      for (let key in data) {
        if (item == key) {
          data[item] == res[key];
        }
      }
    }
    return data;
  }
  toNum(str) {
    return str.replace(/\,|\￥/g, "");
  }
  toPrice(num) {
    num = num.toFixed(2).toString().split(".");
    num[0] = num[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)','ig'),"$1,");
    return num.join(".");
  }
  toPrices(num) {
    num = num.toString().split(".");
    num[0] = num[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)','ig'),"$1,");
    return num.join(".");
  }
  getTime(value) {
    let time = new Date(value);
    return parseInt(time.getTime());
  }
  CalcuMD5(pwd) {
    pwd = pwd.toUpperCase();
    pwd = md5(pwd);
    return pwd;
  }
  timeChange(time) {
    time = String(time);
    if (time.length == 1) {
      return "0" + time;
    } else {
      return time;
    }
  }
  timestampToTime(timestamp) {
    let timestampString = null;
    if (String(timestamp).length == 10) {
      timestampString = timestamp * 1000;
    } else {
      timestampString = timestamp;
    }
    var date = new Date(Number(timestampString)); //时间戳为10位需*1000，时间戳为13位的话不需乘1000

    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = this.timeChange(date.getDate()) + " ";
    var h = this.timeChange(date.getHours()) + ":";
    var m = this.timeChange(date.getMinutes()) + ":";
    var s = date.getSeconds();
    return Y + M + D + h + m + this.timeChange(s);
  }
}
export { utilMethod, md5 };
